import React from 'react';
import LogDetailComponent from './LogDetailComponent';
import LogDetailHeader from './LogDetailHeader';
import { useQueryWithSimpleErrorHandling } from '@ts-private/apollo-tools-ts';
import { LOG_QUERY } from '../../../queries';
import { useSelector, shallowEqual } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Forbidden } from '@totalsoft/rocket-ui';

const LogDetailContainer = () => {
  const params = useParams();
  const { id } = params;

  const [t] = useTranslation();
  const hasRightsToViewLogs = useSelector(state => state.globalRights.menuLogs, shallowEqual);

  const { loading, data: logData } = useQueryWithSimpleErrorHandling(LOG_QUERY, {
    variables: { logId: id }
  });

  return hasRightsToViewLogs ? (
    <>
      <LogDetailHeader />
      <LogDetailComponent log={logData && logData.log} loading={loading}></LogDetailComponent>
    </>
  ) : (
    <Forbidden forbiddenText={t('Unauthorized')} />
  );
};

export default LogDetailContainer;
